import axios from 'axios';

export default axios.create({
  baseURL: 'http://schematic-ipsum.herokuapp.com/',

  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
